import trans from '../../@paco/helpers/trans'

export const SettingsRoutes = {
    manager: () => `${trans('routes.settings.manager.link')}`,
    employee: () => `${trans('routes.settings.employee.link')}`,
    periods: () => `${trans('routes.settings.periods.link')}`,
    groups: (id?: string) => `${trans('routes.settings.departments.link')}${id ? `?id=${id}` : ''}`,
    timer: () => `${trans('routes.settings.timer.link')}`,
    districtDivisionTemplates: () => `${trans('routes.settings.districtDivisionTemplates.link')}`,
    districtDivisionTemplateDetail: (id: string) => `${trans('routes.settings.districtDivisionTemplates.link')}/${id}`,
    changeLogEntries: () => `${trans('routes.settings.changeLogEntries.link')}`,
}
